import { ToastsActions, ToastsActionsNames } from ".";
import { delay, put, takeEvery } from "redux-saga/effects";

import { IActionWithPayload } from "store/helper";

import { IToastsCreatePayload } from "./interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* createToast(action: IActionWithPayload<ToastsActionsNames, IToastsCreatePayload>) {
  const { payload } = action;
  yield put(ToastsActions.showToast({ ...payload }));
  if (payload.autoHideDelayTime) {
    yield delay(payload.autoHideDelayTime);
    yield put(ToastsActions.removeToast({ id: payload.id }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function* archivesSagas() {
  yield takeEvery(ToastsActionsNames.CREATE, createToast);
}
